import type { Slicer } from '@swf/core/store';

import { isDynamicMarketBanner } from '../utils/isDynamicMarketBanner';

import type { SportsCmsBannerWidgetState } from './types';

export const selectors = (slice: Slicer<SportsCmsBannerWidgetState>) => ({
  isLoading: () => slice((state) => state.isLoading),
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  error: () => slice((state) => state.error),
  banners: () => slice((state) => state.banners),
  getMarketIds: () =>
    slice(
      (state) =>
        state.banners?.filter(isDynamicMarketBanner).map(({ market }) => market.marketId) ?? []
    )
});
